<template>
  <div>
    <div
      class="flex !justify-center sm:!justify-start w-full font-bold px-6 pt-4 py-4 text-md "
    >
      <!-- <pre>
      properties {{ properties }}
    </pre
      > -->
      <div class="">
        {{ title }}
      </div>
    </div>
    <div class="my-4">
      <div>
        <v-row class="mb-6 px-10 flex justify-center" no-gutters>
          <v-col
            v-for="(item, i) in properties"
            :key="i"
            class="py-1 text-center"
          >
            <button @click="selectedContract(item)" class="btn w-full">
              <div class="w-full flex justify-center">
                <img
                  src="@/assets/icons/new_icon_house.png"
                  alt=""
                  class="w-32"
                  :class="{ 'opacity-50': item.contract_status === 'INACTIVE' }"
                />
              </div>
              <div
                class="py-2 mt-4 text-sm px-10 text-center flex justify-center"
              >
                <div 
                  class="bg-[#FBE5D6] w-[200px]"
                  :class="{ 'opacity-50': item.contract_status === 'INACTIVE' }"
                >
                  <div class="flex justify-center">
                    {{ item.contract_number }}
                  </div>
                  <div class="flex justify-center">
                    {{ item.project }}
                  </div>
                  <div class="flex justify-center">
                    {{ item.contract_status }}
                  </div>
                </div>
              </div>
            </button>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import SecureStorage from "../../utils/secureStorage.js";
import axios from "axios";

export default {
  watch: {
    "$route.path": {
      async handler(path) {
        if (path == "/property_selection") {
          const cc = SecureStorage.getItem("auth")?.customerCode;
          const parsedCc = parseInt(cc);
          await this.getProperties(parsedCc);
        }
      },
      immediate: true,
    },
    "$route.query.cc": {
      handler(newVal) {
        if (newVal) {
          const parsedCc = SecureStorage.getItem("auth")?.customerCode;
          this.getProperties(parsedCc);
        }
      },
      immediate: true,
    },
  },

  methods: {
    clearPropertyInfo() {
      const itemsToClear = [
        "contract_status",
        "contract_number",
        "property",
        "project",
        "phase",
        "block",
        "lot",
      ];

      // Get current auth data
      const auth = SecureStorage.getItem("auth") || {};

      // Clear each item from auth object
      itemsToClear.forEach((item) => {
        if (auth[item]) delete auth[item];
      });

      // Save updated auth object back
      SecureStorage.setItem("auth", auth);
    },

    setLocalStorageItems(items) {
      // Get current auth data
      const auth = SecureStorage.getItem("auth") || {};

      // Add new items to auth object
      Object.keys(items).forEach((key) => {
        auth[key] = items[key];
      });

      // Save updated auth object back
      SecureStorage.setItem("auth", auth);
    },
    async getPropertyInfo(i) {
      try {
        const response = await this.axios.post("/cs_data/get-property-info", {
          contract_number: i.contract_number,
          customer_code: SecureStorage.getItem("auth")?.customerCode,
          contract_status: i.contract_status,
        });
        return response;
      } catch (error) {
        console.error("Error fetching property info:", error);
        throw new Error(
          "Failed to retrieve property information. Please try again."
        );
      }
    },
    async selectedContract(i) {
      try {
        // Set contract_status immediately
        this.setLocalStorageItems({ contract_status: i.contract_status });

        // Check if the contract is active before fetching property info
        if (i.contract_status === "ACTIVE") {
          const { data } = await this.getPropertyInfo(i);

          // Check if data is not empty and has no errors
          if (data && data.propertyInfo) {
            this.setLocalStorageItems({
              contract_number: data.propertyInfo.contract_number,
              contract_status: i.contract_status,
              property: data.propertyInfo.project,
              project: data.propertyInfo.project,
              phase: data.propertyInfo.phase,
              block: data.propertyInfo.block,
              lot: data.propertyInfo.lot,
            });
          } else {
            console.error("No property information available.");
            alert("Failed to retrieve property information. Please try again.");
            return; // Exit the function if there's an error
          }
        }

        // Redirect to Home Dashboard using query parameters
        this.$router.push({
          name: "Home Dashboard",
          query: {
            cc: this.$route.query.cc,
            cn: i.contract_number,
          },
        });
      } catch (error) {
        console.error("Error in selectedContract:", error);
        alert("An unexpected error occurred. Please try again later.");
      }
    },
    async getProperties(customerCode) {
      try {
        const auth = SecureStorage.getItem("auth");

        const response = await axios.post("/cs_data/get-properties", {
          customerCode: customerCode,
          token: auth?.token,
        });

        if (response.data.status) {
          // Fix: Use property array instead of output
          this.properties = response.data.property || [];
        }
      } catch (error) {
        console.error("Error details:", {
          message: error.message,
          response: error.response?.data,
          requestData: {
            customerCode,
            token: this.auth?.token,
          },
        });
      }
    },
  },
  data() {
    return {
      properties: [],
      title: "Select the property you would like to transact for.",
    };
  },
  props: ["customerCode"],
  mounted() {
    this.clearPropertyInfo();
    const auth = SecureStorage.getItem("auth");
    if (auth?.customerCode) {
      this.getProperties(auth.customerCode); // Pass directly without parsing
    }
  },
};
</script>

<style>
.bg-color {
  background: #033a87;
}
.bg-color:hover {
  background: linear-gradient(-10deg, #7e1e06, #e97e04);
}
</style>
